module.exports = __webpack_public_path__ + "img/patterns_bg.f6f04104.png";